import React from 'react';
import { Box } from '@mui/material';

const AIIcon = ({ size = 32 }) => {
  // Convert string sizes to numeric values
  const getSizeValue = (size) => {
    if (typeof size === 'number') return size;
    const sizeMap = {
      'small': 16,
      'medium': 32,
      'large': 48
    };
    return sizeMap[size] || 32; // Default to 32 if unknown string
  };
  
  const sizeValue = getSizeValue(size);
  // Scale factor to adjust the SVG size
  const scale = sizeValue / 64;
  
  return (
    <Box
      sx={{
        width: sizeValue,
        height: sizeValue,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <svg 
        width={sizeValue} 
        height={sizeValue} 
        viewBox="0 0 64 64" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `scale(${scale})` }}
      >
        {/* Background circle with gradient */}
        <circle cx="32" cy="32" r="30" fill="white" />
        
        {/* Gradient border */}
        <circle 
          cx="32" 
          cy="32" 
          r="30" 
          fill="transparent" 
          stroke="url(#borderGradient)" 
          strokeWidth="1"
        />
        
        {/* Star 1 (main star) */}
        <path 
          d="M32 16L36 28L48 32L36 36L32 48L28 36L16 32L28 28L32 16Z" 
          fill="#735BF3"
        />
        
        {/* Star 2 (top-right small star) */}
        <path 
          d="M44 20L45 24L49 26L45 28L44 32L43 28L39 26L43 24L44 20Z" 
          fill="#735BF3"
        />
        
        {/* Star 3 (bottom-right small star) */}
        <path 
          d="M44 40L45 44L49 46L45 48L44 52L43 48L39 46L43 44L44 40Z" 
          fill="#735BF3"
        />
        
        {/* Gradient definitions */}
        <defs>
          <linearGradient id="borderGradient" x1="0" y1="32" x2="64" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#735BF3" />
            <stop offset="50%" stopColor="#52C5FF" />
            <stop offset="100%" stopColor="#32E170" />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
};

export default AIIcon;
